import request from '@/utils/requestV2'

/**
 * 获取字典
 * @param {Object} data
 * @returns
 */
export function getDictionary (params) {
  return request.get('/ooh-rim/dict/dictionary', { params })
}
